<template>
    <v-card flat class="conteneurKeywords" id="conteneurKeywords" style="width: 100%;">
        <v-card-title class="primary white--text"  style="height: 52px;  padding: 0px;">
          <v-btn icon @click="$emit('justCloseDialog')"><v-icon class="white--text">close</v-icon></v-btn>
          <div class="title tf_title_dialog" v-html="titleDialog"></div>
          <v-spacer></v-spacer>
          <v-btn v-if="$vuetify.breakpoint.smAndDown" flat @click="submitDialog()" class="white--text">{{ $t('submit') }}</v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="loading" class="text-xs-center ">
            <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
          </div>
          <div v-else>
            <v-textarea
              box
              name="question"
              :label="`FAQ: `+ this.$t('exportQuestion')"
              auto-grow
              @input="changeQR(content)"
              :value='content.question'
              v-model="content.question"
            ></v-textarea>

            <v-textarea
              box
              name="reponse"
              :label="`FAQ: `+ this.$t('reponse')"
              auto-grow
              @input="changeQR(content)"
              :value='content.reponse'
              v-model="content.reponse"
            ></v-textarea>
          </div>  
        </v-card-text>
        <v-card-actions v-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement">
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('no') }}</v-btn>
          <v-btn 
            :loading="loadingModif"
            :disabled="!changeContent"
            color="primary"
            @click="submitDialog()"
          >{{ $t('save') }}</v-btn>
        </v-card-actions>
  <!--   
        <v-card-actions v-else-if="!$vuetify.breakpoint.smAndDown && !closeDialogUniquement">
          <v-spacer></v-spacer>
          <v-btn flat @click="$emit('justCloseDialog')">{{ $t('close') }}</v-btn>
          <v-btn color="primary" @click="$emit('closeDialog')">{{ $t('ok') }}</v-btn>
        </v-card-actions>
      -->
        <v-card-actions v-else>
          <v-spacer></v-spacer>
          <v-btn flat @click="closeDialog()">{{ $t('close') }}</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: {
    dataDialog: {
      type: Object,
      default: {}
    },
    titleDialog: {
      type: String,
      default: 'Confirmation'
    },
    afficheDialog: {
      type: Boolean,
      default: false
    },
    closeDialogUniquement: {
      type: Boolean,
      default: false
    },
    numFAQ: {
      type: Number,
      default: ''
    },
    addFAQ: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      name: '',
      content: {question: '', reponse: ''},
      question: '',
      reponse: '',
      loadingModif: false,
      loading: false,
      updatedKeywords: false,
      changeContent: false
    }
  },
  computed: {
    // url du bon serveur (prod / dev)
    serveurAI () {
      if (window.location.origin.indexOf('localhost') > -1) {
        return 'https://lb-sw-generator-dev-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice-preprod') > -1) {
        return 'https://lb-sw-generator-preprod-v2.watcheebox.net/'
      } else if (window.location.origin.indexOf('backoffice') > -1) {
        return 'https://lb-sw-generator.watcheebox.net/'
      } else {
        return 'https://lb-sw-generator.watcheebox.net/'
      }
    }
  },
  mounted () {},
  updated () {},
  methods: {
    closeDialog () {
      // annule les changement dans lle contenu
      if (!this.closeDialogUniquement) {
        this.$emit('closeDialog')
      } else {
        this.$emit('justCloseDialog')
      }
      this.loadingModif = false
    },
    async submitDialog () {
      this.loadingModif = true
      // --- UPDATE
      if (!this.addFAQ) {
        let dataToPost = {}
        dataToPost.nameChunk = this.dataDialog.name
        dataToPost.question = this.content.question
        dataToPost.reponse = this.content.reponse
        dataToPost.content = '\r\n Question : ' + this.content.question + ' \r\n Réponse : ' + this.content.reponse + ' \r\n'
        dataToPost.licKey = this.$store.state._Sites.siteSelected.LIC_KEY
        dataToPost.addFAQ = false
        const responseUpdate = await this.axios.post(this.serveurAI + 'updateChunkFile',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('response update faq ', responseUpdate)
        if (responseUpdate.data.retour) {
          this.loadingModif = false
          this.$emit('majFAQ', dataToPost)
          this.$emit('justCloseDialog')
        } else {
          this.loadingModif = false
        }
      // --- INSERT
      } else {
        let dataToPost = {}
        dataToPost.nameChunk = this.$store.state._Sites.siteSelected.LIC_KEY + '.faq-' + this.numFAQ
        dataToPost.question = this.content.question
        dataToPost.reponse = this.content.reponse
        dataToPost.content = '\r\n Question : ' + this.content.question + ' \r\n Réponse : ' + this.content.reponse + ' \r\n'
        dataToPost.licKey = this.$store.state._Sites.siteSelected.LIC_KEY
        dataToPost.numFAQ = this.numFAQ
        dataToPost.addFAQ = true
        // console.log('sbmitdialog faq add', dataToPost)
        const responseAdd = await this.axios.post(this.serveurAI + 'updateChunkFile',
        dataToPost,
          {headers: {'Content-Type': 'application/json;charset=UTF-8'}}
        )
        // console.log('response add faq ', responseAdd)
        if (responseAdd.data.retour) {
          this.loadingModif = false
          this.$emit('majFAQ', dataToPost)
          this.$emit('justCloseDialog')
        } else {
          this.loadingModif = false
        }
      }
    },
    // ouvre le dialogue de modification les mots clés de la page
    async openDialogUpdateFAQ (data) {
      // console.log('openDialogUpdateFAQ', data)
      this.name = data.name
      this.content.question = (typeof data.question !== 'undefined' && data.question !== '') ? data.question : ''
      this.content.reponse = (typeof data.reponse !== 'undefined' && data.reponse !== '') ? data.reponse : ''
    },
    incrementString (str) {
      // Trouver le dernier nombre dans la chaîne
      const match = str.match(/(\d+)$/)
      // Si un nombre est trouvé
      if (match) {
        const lastNumber = parseInt(match[0]) // Convertir la correspondance en nombre
        const incremented = lastNumber + 1 // Incrémenter le nombre
        const paddedNumber = String(incremented).padStart(match[0].length, '0') // Pad le nombre avec des zéros si nécessaire
        return str.replace(/(\d+)$/, paddedNumber) // Remplacer le dernier nombre par le nombre incrémenté
      } else {
        return str
      }
    },
    // check si le contenu change dans la faq
    changeQR (content) {
      // console.log('changeQR', content)
      if (content.question !== this.dataDialog.question || content.reponse !== this.dataDialog.reponse) {
        this.changeContent = true
      } else {
        this.changeContent = false
      }
    }
  },

  watch: {
    // detect quand la dialogBow est effiché
    afficheDialog: function (val, oldVal) {
      if (val) {
        this.openDialogUpdateFAQ(this.dataDialog)
      }
    }
  }
}
</script>

<style scoped>
  .tf_title_dialog {
    text-overflow: ellipsis;
    width: calc(100% - 180px);
    overflow: hidden;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/watcheezy/WzDialogOpenAIFAQ.vue